var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group mb-0", attrs: { role: "group" } },
    [
      _c("label", { staticClass: "col-form-label pt-0" }, [
        _vm._v("\n        " + _vm._s(_vm.label) + "\n    ")
      ]),
      _vm._v(" "),
      _vm._.get(_vm.config, "description")
        ? _c("small", { staticClass: "form-text mb-2" }, [
            _vm._v(_vm._s(_vm._.get(_vm.config, "description", "")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized
        ? _c("lazy-loading-select-component", {
            attrs: { required: _vm.required, config: _vm.selectConfig },
            on: { change: _vm.onSelect },
            model: {
              value: _vm.selectedPage,
              callback: function($$v) {
                _vm.selectedPage = $$v
              },
              expression: "selectedPage"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "col-form-label pt-0" }, [
        _vm._v("\n        Redirect to this page\n    ")
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control mb-2",
        attrs: {
          type: "text",
          placeholder:
            "Make sure to include 'http://' if linking to an external URL"
        },
        domProps: { value: _vm.value },
        on: { input: _vm.onInput }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f1d38a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f1d38a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/UrlSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-24f1d38a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/UrlSelectComponent.vue
// module chunks = 0